import { useParams, useNavigate } from 'react-router-dom';
import { useGetElcByIdQuery } from 'redux/apiSlice/elcs.slice';
import { TRtkErrorType, useTranslation, Button } from '@packages/utils';
import PageWrapper from 'components/Base/PageWrapper';
import { RoutesPaths } from 'routes/Routes.types';
import PillarsOfStrength from 'pages/private/ELCs/PillarsOfStrength/PillarsOfStrengthExports';
import { useState } from 'react';
import { ActionPlan } from 'assets/icon/icon';
import { useIsFeatureEnabled } from 'hooks/useIsFeatureEnabled';

const ELCPillarsOfStrength = () => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.elcs.list.all-elcs',
  });
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;

  const [, setSelectedLevel] = useState<any>(null);
  const [, setSelectedSubPillar] = useState<any>(null);
  const [, setSelectedTactic] = useState<any>(null);

  const { data, isLoading, error } = useGetElcByIdQuery({
    elcId: id as string,
  });

  const isPillarsManagementEnabled = useIsFeatureEnabled('pillars_management');

  const handleBack = () => {
    if (!id) {
      console.error('Cannot navigate back: Missing ID parameter');
      navigate(`/app/${RoutesPaths.ELCS}`);
      return;
    }

    const elcDetailPath = `/app/${RoutesPaths.ELC_DETAIL.replace(':id', id)}`;
    navigate(elcDetailPath);
  };

  const handleLevelSelected = (level: any, subPillar: any, tactic?: any) => {
    setSelectedLevel(level);
    setSelectedSubPillar(subPillar);
    setSelectedTactic(tactic);
  };

  const handleActionPlanClick = () => {
    if (!id) {
      console.error('Cannot navigate to Action Plan: Missing ID parameter');
      return;
    }
    const actionPlanPath = `/app/${RoutesPaths.ELC_ACTION_PLAN.replace(
      ':id',
      id,
    )}`;
    navigate(actionPlanPath);
  };

  const actionPlanButton = isPillarsManagementEnabled ? (
    <Button
      color="primary"
      onClick={handleActionPlanClick}
      icon={<ActionPlan size={14} />}
    >
      Action Plan
    </Button>
  ) : undefined;

  return (
    <PageWrapper
      title={data?.name}
      backButton={{
        labelPrefix: data?.name || '',
        tooltip: t('TITLE'),
        onClick: handleBack,
      }}
      actions={actionPlanButton}
      isLoading={isLoading}
      error={error as TRtkErrorType}
    >
      <PillarsOfStrength
        elcName={data?.name}
        onLevelSelected={handleLevelSelected}
      />
    </PageWrapper>
  );
};

export default ELCPillarsOfStrength;
